import React, { useEffect, useRef } from "react";
import { useStoreon } from "storeon/react";
import styles from "./styles.module.scss";
import Form from "../components/formWrapper/FormWrapper";
import * as Yup from "yup";
import img from "../../shared/images/settings-background.jpg";
import ProfileForm from "./profileForm";
import PasswordForm from "./passwordForm";
import { withTranslation } from "react-i18next";
import { LOAD_LOGGED_IN_USER_PROFILE } from "../../store/loggedInUserProfile";
import { success, error } from "../components/toast/toast";
import { updateUser, changePassword } from "../../services/usersService";

const Profile = (props) => {
  const { auth, loggedInUserProfile, dispatch } = useStoreon(
    "auth",
    "loggedInUserProfile"
  );
  const { name, last_name, email, id } = loggedInUserProfile;
  const refFormPass = useRef(null);

  useEffect(() => {
    loadUserProfile();
  }, []);

  const loadUserProfile = () => {
    const loggedInUser = localStorage.getItem("loggedInUser");
    const loggedInUserObj = JSON.parse(loggedInUser);
    dispatch(LOAD_LOGGED_IN_USER_PROFILE, { id: loggedInUserObj.id });
  };

  const initForm = {
    name: name,
    lastName: last_name,
    email: email,
  };

  const initPasswordForm = {
    oldPassword: "",
    password: "",
    confirmPassword: "",
  };

  const handleSubmit = (values, status) => {
    return updateUser(auth, values, id).then((res) => {
      if (res.success !== false) {
        success("Profile successfully updated", { onClose: () => {} });
        loadUserProfile();
      } else {
        if (res.message && res.message === "duplicated entry") {
          error("Provided email is already taken.", { onClose: () => {} });
        }

        if (
          res.message &&
          typeof res.message !== "string" &&
          res.message.length
        ) {
          res.message.forEach((message) => {
            error(message, { onClose: () => {} });
          });
        }
      }
      return res;
    });
  };

  const handleSubmitPassword = (values, status) => {
    return changePassword(auth, values).then((res) => {
      if (res.success !== false) {
        success("Password successfully updated", { onClose: () => {} });
        refFormPass.current.resetForm();
      } else {
        if (
          res.message &&
          typeof res.message !== "string" &&
          res.message.length
        ) {
          res.message.forEach((message) => {
            error(message, { onClose: () => {} });
          });
        }

        error(res.message, { onClose: () => {} });
      }
      return res;
    });
  };

  const renderComponent = (props) => {
    return <ProfileForm {...props} handleSubmit={handleSubmit} />;
  };

  const renderComponentPassword = (props) => {
    return <PasswordForm {...props} handleSubmit={handleSubmitPassword} />;
  };

  const { t } = props;

  return (
    <div className={styles.overallContainer}>
      <div className={styles.lines}></div>
      <div className={styles.bodyContainer}>
        <Form
          initialValues={initForm}
          component={renderComponent}
          enableReinitialize={true}
          validationSchema={Yup.object().shape({
            name: Yup.string().required(t("common:validations.required")),
            lastName: Yup.string().required(t("common:validations.required")),
            email: Yup.string()
              .matches(
                new RegExp(
                  /^[a-z0-9]+([.-\\+]?[a-z0-9]+)*@[a-z]+([.-]?[a-z0-9]+)*(\.[a-z]{2,3})+$/
                ),
                t("common:validations.email")
              )
              .required(t("common:validations.required")),
          })}
        />
        <Form
          initialValues={initPasswordForm}
          component={renderComponentPassword}
          enableReinitialize={true}
          innerRef={refFormPass}
          validationSchema={Yup.object().shape(
            {
              password: Yup.string().when("oldPassword", {
                is: (val) => !!val,
                then: Yup.string().required(t("common:validations.required")),
              }),
              confirmPassword: Yup.string()
                .oneOf([Yup.ref("password")], "Passwords must match")
                .when("password", {
                  is: (val) => !!val,
                  then: Yup.string().required(t("common:validations.required")),
                  otherwise: Yup.string(),
                }),
              oldPassword: Yup.string().required(
                t("common:validations.required")
              ),
            },
            ["password", "oldPassword"]
          )}
        />
      </div>
      <div
        className={styles.backgroundImage}
        style={{
          backgroundImage: `url(${img})`,
        }}
      ></div>
    </div>
  );
};

export default withTranslation("common")(Profile);
